module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"31/30","short_name":"31/30","description":"31 intermedia projects over 30 years, 1992 to 2022","start_url":"/","background_color":"#fff","theme_color":"#242943","display":"minimal-ui","icon":"src/images/emb-site-icon_512x512.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"bde2da870f71fd80c483361735903001"},
    },{
      plugin: require('../gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
